import React from 'react';
import { Button } from '@/components/ui/button';
import { X, FileText, Lock } from 'lucide-react';

const ResourcePreviewModal = ({ resource, isOpen, onClose }) => {
  if (!isOpen || !resource) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl max-w-3xl w-full max-h-[90vh] overflow-hidden shadow-2xl">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b" style={{borderColor: 'rgba(183, 191, 114, 0.20)'}}>
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{background: 'rgba(0, 108, 105, 0.10)'}}>
              <FileText className="w-5 h-5" style={{color: '#006C69'}} />
            </div>
            <div>
              <h2 className="text-2xl font-bold text-gray-900">{resource.title}</h2>
              <p className="text-sm text-gray-500">{resource.type} • {resource.fileSize}</p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-full transition-colors"
          >
            <X className="w-6 h-6 text-gray-500" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 overflow-y-auto max-h-[60vh]">
          <div className="mb-6">
            <h3 className="text-lg font-bold mb-2 text-gray-900">Overview</h3>
            <p className="text-gray-600 leading-relaxed">
              {resource.description}
            </p>
          </div>

          {resource.previewContent && (
            <div className="mb-6">
              <h3 className="text-lg font-bold mb-3 text-gray-900">Preview</h3>
              <div className="bg-gray-50 p-6 rounded-lg border-2" style={{borderColor: 'rgba(0, 108, 105, 0.10)'}}>
                <p className="text-gray-700 leading-relaxed whitespace-pre-line">
                  {resource.previewContent}
                </p>
              </div>
              {resource.isPremium && (
                <div className="mt-4 p-4 bg-gradient-to-r from-yellow-50 to-amber-50 rounded-lg border" style={{borderColor: 'rgba(183, 191, 114, 0.30)'}}>
                  <div className="flex items-center gap-2 mb-2">
                    <Lock className="w-4 h-4" style={{color: '#B7BF72'}} />
                    <span className="font-semibold" style={{color: '#B7BF72'}}>Full content is premium</span>
                  </div>
                  <p className="text-sm text-gray-600">
                    This is a preview. Get full access with a premium subscription.
                  </p>
                </div>
              )}
            </div>
          )}

          <div className="grid md:grid-cols-3 gap-4 mb-6">
            <div className="p-4 bg-gray-50 rounded-lg">
              <p className="text-sm text-gray-500 mb-1">Difficulty</p>
              <p className="font-semibold text-gray-900">{resource.difficulty}</p>
            </div>
            <div className="p-4 bg-gray-50 rounded-lg">
              <p className="text-sm text-gray-500 mb-1">File Size</p>
              <p className="font-semibold text-gray-900">{resource.fileSize}</p>
            </div>
            <div className="p-4 bg-gray-50 rounded-lg">
              <p className="text-sm text-gray-500 mb-1">Type</p>
              <p className="font-semibold text-gray-900">{resource.type}</p>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="p-6 border-t bg-gray-50" style={{borderColor: 'rgba(183, 191, 114, 0.20)'}}>
          <div className="flex items-center justify-between gap-4">
            <Button
              onClick={onClose}
              variant="outline"
              className="font-semibold"
            >
              Close Preview
            </Button>
            {!resource.isPremium && (
              <Button
                className="font-semibold"
                style={{
                  background: '#006C69',
                  color: '#FFFFFF'
                }}
              >
                Download Full Resource
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResourcePreviewModal;
